<script>
import { mapState, mapActions } from "vuex"
import DetailsContainer from "@/components/global/DetailsContainer"
import DetailsTopBar from "@/components/global/DetailsTopBar"
import IncidentModal from "@/components/global/IncidentModal" 
import Config from "@/config"
import validation from "@/mixins/validation"

export default {
  components: {
    DetailsContainer,
    DetailsTopBar,
    IncidentModal,
  },
  mixins: [
    validation,
  ],
  props: {
    id: { default: null, type: Number },
  },
  data() { 
    return {
      debug: false,
      jpubId: null,
      buttonVariant: "light",
      allDataExpanded: true,
      activtyExpanded: false,
      canEditJournalPublisherRecord: true,
      displayName: "Sent from Publisher Details",
      sections: [
        {
          id: "publistJournalDetails",
          title: "Journal Publisher Details",
          type: "detailsContainer",
          mapping: [
            { field: "jpubId", label: "Publisher ID", cols: 6, type: "text", readOnly: true, template: false },
            { field: "jpubStatus", label: "Publisher Status", cols: 6, type: "authorstatuspicker", readOnly: false, template: false,
              message: "Publisher Status is required.",
              validation: {
                rules: {
                  required: true,
                },
              },
            },
            { field: "jpubName", label: "Publisher", cols: 12, type: "text", readOnly: false, template: false,
              message: "Publisher is required.",
              validation: {
                rules: {
                  required: true,
                },
              }, 
            },
            { field: "jpubUrl", label: "Publisher URL", cols: 12, type: "text", readOnly: false},
            { field: "jpubRefer", label: "Publisher Reference", cols: 12, type: "text", readOnly: false, template: false, 
              message: "Journal Publisher Reference Must be numeric",
              validation: {
                rules: {
                  numeric: true,
                },
              },
            },
            { field: "jpubComment", label: "Publisher Comment", cols: 12, type: "textarea", readOnly: false, template: false},
            { field: "created", label: "Created", cols: 2, type: "datepicker", readOnly: true, switch: true, exclude: true },
            { field: "updated", label: "Updated", cols: 2, type: "datepicker", readOnly: true, switch: true, exclude: true },
            
          ],
          rows: [],
          expanded: true,
        },
      ],
    }
  },

  computed: {
    ...mapState("auth", [
      "email",
      "personId",
      "username",
    ]),
    incidentGroup() {
      return Config.publication.incidentGroup
    },
  
    editModalFooterButtons() {
      const btns = {
        rightButtons: [
          {
            id: "cancelButton",
            text: "Cancel",
            variant: "secondary",
          },
          {
            id: "saveButton",
            text: "Save",
            variant: "primary",
          },
        ],
        
      }

      return btns
    },
    detailsTopBarItems() {
      const items = []

      items.push({
        id: "saveRecordButton",
        type: "button",
        label: "Save",
        position: "right",
        variant: this.buttonVariant,
      })
      items.push({
        id: "createIncidentButton",
        type: "button",
        label: "Create Incident",
        position: "right",
        variant: "light",
      })

      return items
    },
    templateData() {
      const results = []

      this.sections.forEach(section => {
        if (section.type == "detailsContainer") {
          section.rows.forEach(row => {
            row.items.forEach(itm => {
              if (itm.template) {
                results.push({
                  type: itm.type,
                  value: itm.data.value,
                  id: itm.data.id,
                  label: itm.data.label,
                  data: {
                    id: itm.data.id.replace("field_", ""),
                    readOnly: false,
                    switch: true,
                    clearable: true,
                    value: itm.data.value,
                  },
                })
              }
            })
          })
        }
      })

      return results
    },

  },
  watch: {
    $route() {
      if (
        (typeof this.$route.params === "undefined",
        typeof this.$route.params.params === "undefined")
      ) {
        this.error = "Missing Pubs ID Parameter"
      } else if (isNaN(this.$route.params.params)) {
        this.error = "Invalid Pubs ID Format"
      } else {
        if (this.pId != parseInt(this.$route.params.params)) {
          this.updateView()
        }
      }
    },
  },
  created() {
    this.updateView()
  },
  methods: {
    updateView() {
      if (
        (typeof this.$route.params === "undefined",
        typeof this.$route.params.params === "undefined")
      ) {
        this.error = "Missing JOURNAL PUBLISHER Parameter"
      } else if (isNaN(this.$route.params.params)) {
        this.error = "Invalid JPUBID Format"
      } else {
        this.jpubId = parseInt(this.$route.params.params)
        this.retrieveData()
      }
    },
    retrieveData() {    
      this.$store.dispatch("publication/getPublistJournalsById", this.jpubId).then((data) => {
        const dataArr = []
        let dataArrResults = {}
        dataArr.push(data)
        dataArr.forEach(itm => {
          dataArrResults = itm
        })
        this.parseData(dataArrResults)
      })
    },
    parseData(data) {
      const returnedStatus = this.getStatus(data)
      if (this.debug) console.log("[JournalPublistDetails.vue parseData] data:", data)
      this.sections.forEach(section => {
        if (section.type == "detailsContainer") {
          const rows = []
          section.mapping.forEach(mapping => {
            if (mapping.type == "alert") {
              rows.push({
                data: {
                  message: mapping.message,
                  variant: mapping.variant,
                },
                type: mapping.type,
                cols: mapping.cols,
              })
            } else {
              let template = true
              if (Object.keys(mapping).indexOf("template") > -1) template = mapping.template
              // here we handle edge case for status detail instead of status id
              if (mapping.field === "jpubStatus") {
                rows.push({
                  data: {
                    id: `field_${mapping.field}`,
                    label: mapping.label,
                    value: typeof(returnedStatus) != "undefined" ? returnedStatus : "",
                    switch: mapping.switch,
                    prepend: mapping.prepend,
                    readOnly: this.canEditJournalPublisherRecord ? mapping.readOnly : true,
                    defaultLabel: mapping.defaultLabel,
                    message: mapping.message,
                    state: mapping.state,
                  },
                  validation: mapping.validation,
                  type: mapping.type,
                  cols: mapping.cols,
                  exclude: mapping.exclude,
                  template,
                })
              } else {
                rows.push({
                  data: {
                    id: `field_${mapping.field}`,
                    label: mapping.label,
                    value: typeof(data[mapping.field]) != "undefined" ? data[mapping.field] : "",
                    switch: mapping.switch,
                    prepend: mapping.prepend,
                    readOnly: this.canEditJournalPublisherRecord ? mapping.readOnly : true,
                    defaultLabel: mapping.defaultLabel,
                    message: mapping.message,
                    state: mapping.state,
                  },
                  validation: mapping.validation,
                  type: mapping.type,
                  cols: mapping.cols,
                  exclude: mapping.exclude,
                  template,
                })
              }

            }
          })
          section.rows = [{
            items: rows,
          }]
        }
      })
    },

    getStatus(data) {
      for (const [key, value] of Object.entries(data)) {
        if (key === "publistStatusByJpubStatus") {
          return value.statusId
        }
      }
    },
   
    onTopBarButtonClick(id) {
      if (this.debug) console.log("[JournalPublistDetails.vue onTopBarButtonClick] id:", id)
      if (id == "saveRecordButton") {
        this.saveRecord()
      } else if (id == "createIncidentButton") {
        if (this.email == "") {
          this.$store.dispatch("auth/retrieveEmail")
        }
        this.$bvModal.show("createIncidentModal")
      }
    },
    saveRecord() {
      if (!this.checkSchemaState(this.sections)) {
        this.showErrorSummary()
        return
      }

      const data = []
      this.sections.forEach(section => {
        if (Object.keys(section).indexOf("rows") > -1) {
          section.rows.forEach(row => {
            if (Object.keys(row).indexOf("items") > -1) {
              row.items.forEach(item => {
                data[`${item.data.id}`.replace("field_", "")] = item.data.value
              })
            }
          })
        }
      })
      if (this.debug) console.log("[JournalPublistDetails.vue saveRecord] Data to Save:", data)

      this.$store.dispatch("publication/updatePublisherByJpubId", data).then(resp => {
        // const dat = data
        if (resp) {
          this.$bvToast.toast(`Your modifications have been saved.`, {
            title: "Publisher Saved",
            autoHideDelay: 5000,
            variant: "success",
          })
        } 
      }).catch(error => {
        console.log(error)
        this.$bvToast.toast(`Your modifications failed to save.`, {
          title: "Publisher Save Failed",
          autoHideDelay: 10000,
          variant: "danger",
        }) 
      })

    },
  },
}
</script>

<template>
  <div id="publicationDetails">
    <DetailsTopBar :items="detailsTopBarItems" @buttonClick="onTopBarButtonClick" />
    <div class="PageContent">
      <template v-for="section in sections">
        <DetailsContainer 
          v-if="section.type == 'detailsContainer'"
          :key="section.id"
          :title="section.title" 
          :rows="section.rows" 
          :expanded="section.expanded"
          @expandToggle="section.expanded = !section.expanded"
        />
      </template>
    </div>
    <IncidentModal
      :group="incidentGroup"
      :displayName="incDisplayName"
    />
  </div>
</template>

<style>
.minDateWidth {
  width: 200px;
}
</style>
